export default "__VITE_ASSET__BINPOCl8__"